import React from "react";
import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import DataParser from "../../utlits/Dataparser";

const PermissionRoute = ({ requiredPermission, children }) => {
    let adminInfo;
    let userRole;
    let permissions = [];

    try {
        const storedInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
        if (storedInfo) {
            adminInfo = storedInfo;
            userRole = adminInfo?.user?.userdata?.role_title;
            permissions = adminInfo?.user?.userdata?.user_permissions || [];
        }
    } catch (error) {
        console.error("PermissionRoute: Failed to parse user data", error);
        // If data is corrupted, redirect to login or show unauthorized?
        // Let's assume unauthorized/login for safety
        return <Navigate to="/" />;
    }

    if (!adminInfo) {
        return <Navigate to="/" />;
    }

    // Company Admin has full access
    if (userRole?.toLowerCase() === "company admin") {
        return children;
    }

    // Validating if permissions is an array of strings
    let hasPermission = false;
    if (Array.isArray(permissions)) {
        if (Array.isArray(requiredPermission)) {
            // Check if user has AT LEAST ONE of the required permissions (OR logic)
            hasPermission = requiredPermission.some(rp => permissions.includes(rp));
        } else {
            // Single permission check
            hasPermission = permissions.includes(requiredPermission);
        }
    }

    if (!hasPermission) {
        console.warn(`⛔ Blocked access to restricted route. Required: ${requiredPermission}, Have:`, permissions);
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default PermissionRoute;
